import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import apiUrl from '../../Environment/Api';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { CSVLink } from 'react-csv';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as XLSX from 'xlsx';
import { useNavigate } from 'react-router-dom';
import logo from '../../../assets/img/Admin/Logo.png';

function Projectreport() {
    const navigate = useNavigate();
    const tableRef = useRef(null);
    const [originalData, setOriginalData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [copied, setCopied] = useState(false);

    const getdata = async () => {
        try {
            const response = await axios.get(apiUrl + '/invoicelist');
            console.log("API Response:", response);
            console.log("Data Length:", response.data.length);
            setOriginalData(response.data);
            setFilteredData(response.data);
            console.log(filteredData)
        } catch (error) {
            console.log("Error fetching data:", error);
        }
    };

    const [getclientdetails, setclientdetails] = useState([])
    const clientdetails = async () => {
        try {
            const response = await axios.get(apiUrl + '/clientdetails');
            setclientdetails(response.data);
        }
        catch (error) {
            console.log(error)
        }
    }


    useEffect(() => {
        getdata();
        clientdetails();
    }, []);

    const handlesearchFilter = (e) => {
        e.preventDefault();
        const inputValue = e.target.value.trim().toLowerCase();
        const filteredData = originalData.filter((data) =>
            Object.values(data).some(
                (value) =>
                    value.toString().toLowerCase().includes(inputValue)
            )
        );

        setFilteredData(filteredData);
    };


    const generatePDF = () => {
        const pdf = new jsPDF();

        // Load your logo image
        const logoImage = new Image();
        logoImage.src = logo;

        const logoWidth = 25;
        const logoHeight = 25;

        // Add logo image to the PDF on the left side
        pdf.addImage(logoImage, 'PNG', 15, 5, logoWidth, logoHeight);

        // Add information on the right end
        const rightEndX = pdf.internal.pageSize.getWidth() - 10;
        const rightEndY = 0; // Adjust the Y-coordinate as needed

        // Font size for text
        const fontSize = 8;

        // Margin top for text content
        const marginTopText = 8;

        // FontAwesome icons
        const faAddress = 'f095'; // FontAwesome icon for address

        // Add sample words with text and FontAwesome icons
        pdf.setFontSize(fontSize);
        pdf.text(rightEndX - 50, rightEndY + marginTopText + 4, 'VAS Post Production');
        pdf.text(rightEndX - 50, rightEndY + marginTopText + 8, 'Vasanthan. K');
        pdf.text(rightEndX - 50, rightEndY + marginTopText + 12, `87, Kamarajar Nagar,\nDadagapatti,\nSalem-6`);

        const marginTop = 35;
        pdf.autoTable({ html: tableRef.current, startY: marginTop });

        pdf.save('Reports.pdf');
    };


    const generateExcel = () => {
        // Remove the 'id' column and add a new 'S No.' column
        const dataWithoutId = filteredData.map((data, index) => {
            const { id, ...rest } = data;
            return { 'S No.': index + 1, ...rest };
        });

        const header = Object.keys(dataWithoutId[0]);
        const rows = dataWithoutId.map(data => Object.values(data));

        const ws = XLSX.utils.aoa_to_sheet([header, ...rows]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Reports');

        XLSX.writeFile(wb, 'Reports.xlsx');
    };

    const copyToClipboard = () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    const handletoprint = () => {
        navigate('/reportprint')
    }




    const [selectedproject, setSelectedproject] = useState('');
    const [selectedinvoiceid, setSelectedinvoiceid] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const handleFilterClick = (e) => {
        e.preventDefault();
        let newData = originalData.slice();
        if (selectedproject && selectedproject !== "All Client") {
            newData = newData.filter((data) => data.clientName === selectedproject);
        }
        if (selectedproject === "All Client") {
        }
        if (selectedinvoiceid) {
            newData = newData.filter((data) => data.type === selectedinvoiceid);
        }
        if (fromDate && toDate) {
            newData = newData.filter((data) => {
                const dataDate = new Date(data.date);
                const fromDateTime = new Date(fromDate);
                const toDateTime = new Date(toDate);

                return dataDate >= fromDateTime && dataDate <= toDateTime;
            });
        }
        setFilteredData(newData);
    };


    const getUniqueTypes = (client) => {
        let filteredDataForProject = originalData;
        if (client) {
            filteredDataForProject = originalData.filter((data) => data.clientName === client);
        }
        const types = [...new Set(filteredDataForProject.map((data) => data.type))];
        return types;
    };




    const getUniqueClientNames = () => {
        const uniqueClientNames = [...new Set(originalData.map((data) => data.clientName))];
        return uniqueClientNames;
    };


    //pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice().reverse().slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const handleItemsPerPageChange = (e) => {
        setCurrentPage(1);
        setItemsPerPage(Number(e.target.value));
    };


    const clearFilters = (e) => {
        e.preventDefault();
        setSelectedproject('');
        setSelectedinvoiceid('');
        setFromDate('');
        setToDate('');
        setFilteredData(originalData);
    };


    const printTable = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Print</title>');
        printWindow.document.write('<style type="text/css">');
        printWindow.document.write(`
          body {
            text-align: center;
          }
      
          h1 {
            margin-top: 20px;
          }
      
          table {
            border-collapse: collapse;
            width: 100%;
            margin-top: 20px;
          }
      
          table, th, td {
            border: 1px solid black;
          }
      
          th, td {
            padding: 10px;
            text-align: left;
          }
        `);
        printWindow.document.write('</style></head><body>');

        // Centered heading
        printWindow.document.write('<h1>Project Reports</h1>');

        // Check if the element with ID 'table-container' exists before accessing its innerHTML
        const tableContainer = document.getElementById('table-container');
        if (tableContainer) {
            // Add your table to the print window
            printWindow.document.write(tableContainer.innerHTML);
        } else {
            console.error("Element with ID 'table-container' not found");
        }

        printWindow.document.write('</body></html>');

        setTimeout(() => {
            printWindow.print();
            // Close the print window after printing
            printWindow.close();
        }, 1000);
    };


    const formatDate = (dateString) => {
        if (!dateString || dateString === "Invalid Date") {
            return ""; // Return empty string for invalid or empty dates
        }

        const date = new Date(dateString);
        const formattedDate = date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }).replace(/\//g, '-'); // Replace slashes with hyphens

        return formattedDate;
    };





    return (
        <>
            <div>
                <div className='card cardshadow'>
                    <div className="text-center">
                        <h5 className="mt-2">Project Reports</h5>
                    </div>
                    <hr />

                    <div>
                        <form className='projectfilter-wrap p-3'>
                            <div className='mx-3 dropdown'>
                                <label className='form-label'>Client Name</label>
                                <div className="position-relative">
                                    <select
                                        className='form-control dropdown-toggle custom-select'
                                        value={selectedproject}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            setSelectedproject(selectedValue);
                                            setSelectedinvoiceid('');
                                            if (selectedValue === "") {
                                                setSelectedproject("");
                                            }
                                        }}
                                    >
                                        <option value="" disabled>Select Client</option>
                                        <option value="All Client">All Client</option>
                                        {getUniqueClientNames().map((clientName, index) => (
                                            <option
                                                key={index}
                                                value={clientName}

                                            >
                                                {clientName}
                                            </option>
                                        ))}
                                    </select>
                                    <div className="dropdown-arrow"></div>
                                </div>
                            </div>
                            <div className='mx-3 dropdown'>
                                <label className='form-label'>Type</label>
                                <div className="position-relative">
                                    <select
                                        className='form-control dropdown-toggle custom-select'
                                        value={selectedinvoiceid}
                                        onChange={(e) => setSelectedinvoiceid(e.target.value)}
                                    >
                                        <option value="" disabled>Select Type</option>
                                        {selectedproject === "All Client" ?
                                            getUniqueTypes().map((type, index) => (
                                                <option key={index} value={type}>
                                                    {type}
                                                </option>
                                            )) :
                                            getUniqueTypes(selectedproject).map((type, index) => (
                                                <option key={index} value={type}>
                                                    {type}
                                                </option>
                                            ))
                                        }
                                    </select>
                                    <div className="dropdown-arrow"></div>
                                </div>
                            </div>
                            <div className='mx-3'>
                                <label className='form-label'>From Date</label>
                                <input
                                    type='date'
                                    className='form-control'
                                    value={fromDate}
                                    onChange={(e) => setFromDate(e.target.value)}
                                />
                            </div>
                            <div className='mx-3'>
                                <label className='form-label'>To Date</label>
                                <input
                                    type='date'
                                    className='form-control'
                                    value={toDate}
                                    onChange={(e) => setToDate(e.target.value)}
                                />
                            </div>
                            <div className='mx-3'>
                                <button onClick={handleFilterClick} className='btn btn-primary filterbutton'><i className="fa-solid fa-filter"></i></button>
                                <button onClick={clearFilters} className='btn btn-secondary clearbutton mx-2'>clear</button>
                            </div>
                        </form>

                    </div>
                </div>
                <div className='d-flex justify-content-between '>
                    <form className='seach-content'>
                        <label>Show per page:</label>
                        <select className='form-control' value={itemsPerPage} onChange={handleItemsPerPageChange}>
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={200}>200</option>
                            <option value={500}>500</option>
                        </select>
                    </form>
                    <div className='button-save' style={{ height: '20px' }}>
                        <CopyToClipboard text={JSON.stringify(filteredData)} onCopy={copyToClipboard}>
                            <button className='btn btn-sm btn-secondary mx-1'>
                                {copied ? 'Copied!' : 'Copy'}
                            </button>
                        </CopyToClipboard>
                        <CSVLink data={filteredData} filename={'Reports.csv'}>
                            <button className='btn btn-sm btn-secondary mx-1'>CSV</button>
                        </CSVLink>
                        <button className="btn btn-sm btn-secondary mx-1" onClick={generateExcel}>
                            Excel
                        </button>
                        <button className='btn btn-sm btn-secondary mx-1' onClick={generatePDF}>
                            PDF
                        </button>
                        <button className='btn btn-sm btn-secondary mx-1' onClick={printTable}>Print</button>
                    </div>
                    <form className='seach-content'>
                        <label>Search :</label>
                        <input className='form-control' type='text' onChange={handlesearchFilter}></input>
                    </form>
                </div>
                <div id="table-container" className='table-responsive'>
                    <table ref={tableRef} class="table table-striped">
                        <thead>
                            <tr className='tr-heading'>
                                <th>S.No</th>
                                <th>Client Name</th>
                                <th>Date</th>
                                <th>Project Name</th>
                                <th>Type</th>
                                <th>Qty</th>
                                <th>Price</th>
                                <th>Paypal Tax(%)</th>
                                <th>Total Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.map((data, index) => (
                                <tr key={index} className="tr-shadow">
                                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                    <td>{data.clientName}</td>
                                    <td>{formatDate(data.date)}</td>
                                    <td>{data.projectName}</td>
                                    <td>{data.type}</td>
                                    <td>{data.quantity}</td>
                                    <td>{data.price}</td>
                                    <td>{data.tax}</td>
                                    {/* <td>$ {data.totalAmount}</td> */}
                                    <td>
                                        {(() => {
                                            const clientData = getclientdetails.find(client => client.id === data.clientId);

                                            if (clientData) {
                                                const currencySymbol = clientData.countrycode === '91' ? 'INR' : '$';
                                                return (
                                                    <span>
                                                        {currencySymbol} {Number(data.totalAmount).toFixed(2)}
                                                    </span>
                                                );
                                            }
                                            return null;
                                        })()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div>
                    <nav className='d-flex justify-content-end mx-2 pt-4'>
                        <ul className="pagination">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button className="page-link mx-3" onClick={() => paginate(currentPage - 1)}>
                                    Previous
                                </button>
                            </li>
                            {Array.from({ length: Math.ceil(filteredData.length / itemsPerPage) }, (_, index) => (
                                <li key={index} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => paginate(index + 1)}>
                                        {index + 1}
                                    </button>
                                </li>
                            ))}
                            <li className={`page-item ${currentPage === Math.ceil(filteredData.length / itemsPerPage) ? 'disabled' : ''}`}>
                                <button className="page-link mx-3" onClick={() => paginate(currentPage + 1)}>
                                    Next
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </>

    )
}
export default Projectreport;